import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerImageStyle = css`
  width: fit-content;
  background-color: ${theme.colors.neutral[10]};
  padding: ${theme.spacing(2)};
  margin-top: ${theme.spacing(2)};
`;

export const imageStyle = css`
  width: 320px;
  border-radius: ${theme.borderRadius.small};
`;

export const cardCaptureFieldContainerStyle = css`
  padding: ${theme.spacing(2)};
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.small};
`;
export const hrStyle = css`
  border: none;
  border-top: 1px solid ${theme.colors.neutral[5]};
  margin-bottom: ${theme.spacing(3)};
`;

export const headingSpacingStyle = css`
  margin-bottom: ${theme.spacing(2)};
`;
